import React, {useEffect, useState} from 'react';
import {Navigate, Link, useNavigate} from 'react-router-dom';
import {useAuth} from '../../../contexts/authContext';
import {doCreateUserWithEmailAndPassword, doSignUpWithGoogle} from '../../../service/auth';
import {Form, Input, Button, message, Typography, Space, Divider} from 'antd';
import { FcGoogle } from "react-icons/fc";

const {Title, Text} = Typography;

const Register = () => {
    const navigate = useNavigate();
    const {userLoggedIn} = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        document.title = 'Signup - CV Postman App';
    }, []);

    const onSubmit = async () => {
        if (!isRegistering) {
            setIsRegistering(true);
            try {
                await doCreateUserWithEmailAndPassword(email, password);
                navigate('/login');
            } catch (err) {
                setErrorMessage(err.message);
                setIsRegistering(false);
            }
        }
    };

    const handleGoogleSignup = async () => {
        setGoogleLoading(true);
        try {
            let result = await doSignUpWithGoogle();
            if(result?.user?.email) {
                //message.success('Google sign-up successful! 🎉');
            } else {
                message.error(result?.error);
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setGoogleLoading(false);
        }
    };

    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            {userLoggedIn && <Navigate to="/onboarding" replace/>}

            <div style={{width: 400, padding: 24, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: 8}}>
                <Title level={3} style={{textAlign: 'center'}}>Create a New Account</Title>

                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{required: true, message: 'Please enter your email!'}]}
                    >
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            disabled={isRegistering}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{required: true, message: 'Please enter your password!'}]}
                    >
                        <Input.Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            disabled={isRegistering}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Confirm Password"
                        name="confirmPassword"
                        rules={[
                            {required: true, message: 'Please confirm your password!'},
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Passwords do not match!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your password"
                            disabled={isRegistering}
                        />
                    </Form.Item>

                    {errorMessage && <Text type="danger">{errorMessage}</Text>}

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={isRegistering}
                            disabled={isRegistering}
                        >
                            {isRegistering ? 'Signing Up...' : 'Sign Up'}
                        </Button>
                    </Form.Item>
                    <Divider>OR</Divider>

                    <Form.Item>
                        <Button
                            icon={<FcGoogle size={20} />}
                            type="default"
                            onClick={handleGoogleSignup}
                            loading={googleLoading}
                            block
                        >
                            Sing Up with Google
                        </Button>
                    </Form.Item>
                </Form>

                <Space direction="vertical" style={{width: '100%'}}>
                    <Text style={{textAlign: 'center'}}>
                        Already have an account?{' '}
                        <Link to="/login">Log in</Link>
                    </Text>
                </Space>
            </div>
        </div>
    );
};

export default Register;
